module.exports = __webpack_public_path__ + "static/media/DetailsEpsonCRProjector1.14c41e3b.png";